import React, { FC } from 'react'
import { useRules } from '../../hooks/useRules'

import Loader from 'uiKit/loaders/loader'
import { RuleTile } from './RuleTile'

type RulesListProps = {
  search: string
}

export const RulesList: FC<RulesListProps> = ({ search = '' }) => {
  const { data: rules = [], loading } = useRules()

  if (!rules?.length && loading) {
    return (
      <div style={{ margin: '40px auto' }}>
        <Loader />
      </div>
    )
  }

  return (
    <div>
      {rules.map((ruleItem, index) => (
        <RuleTile key={index} index={index} rule={ruleItem} search={search} />
      ))}
    </div>
  )
}
